import { Injectable } from '@angular/core';
import { ConfirmationService, Confirmation } from 'primeng/api';

@Injectable()
export class CustomConfirmationService extends ConfirmationService {
  override confirm(confirmation?: Confirmation): this {
    const defaultAccept = { styleClass: 'confirm-accept-btn' };
    const defaultReject = { styleClass: 'confirm-reject-btn' };

    const opts = { ...(confirmation || {}) } as any;

    if (opts.acceptButtonProps) {
      opts.acceptButtonProps = { ...defaultAccept, ...opts.acceptButtonProps };
    } else {
      opts.acceptButtonProps = defaultAccept;
    }

    if (opts.rejectButtonProps) {
      opts.rejectButtonProps = { ...defaultReject, ...opts.rejectButtonProps };
    } else {
      opts.rejectButtonProps = defaultReject;
    }

    super.confirm(opts);
    return this;
  }
}
